export enum PspTypeEnum {
    PspPatient = 1,
    PspCareGiver
}

export enum PspMedicalRequestTypeEnum {
  HomeDelivery = 1,
  Pickup
}
